/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_Notes_Surround_DoubleInputs */



/**
* | output |
* | --- |
* | "Surround Double (♪♪... ♪♪)" |
*
* @param {Music_Notes_Surround_DoubleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes_surround_double = /** @type {((inputs?: Music_Notes_Surround_DoubleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_Notes_Surround_DoubleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encadrer double (♪♪... ♪♪)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Surround Double (♪♪... ♪♪)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Doppio surround (♪♪... ♪♪)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Двойной объемный звук (♪♪... ♪♪)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Doble envolvente (♪♪... ♪♪)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("环绕双音效 (♪♪... ♪♪)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サラウンドダブル（♪♪…♪♪）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सराउंड डबल (♪♪... ♪♪)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Surround Duplo (♪♪... ♪♪)")
	return /** @type {LocalizedString} */ ("Surround Double (♪♪... ♪♪)")
});